import { useState } from 'preact/hooks';
import { useTooltipControlled } from './useTooltipControlled';

type tooltipParameters = Parameters<typeof useTooltipControlled>[0];

type Props = {
  text?: string;
  position?: tooltipParameters['position'];
  isDisabled?: boolean;
  anchor?: tooltipParameters['anchor'];
  offset?: { mainAxis?: number; crossAxis?: number };
  variant?: tooltipParameters['variant'];
};

export const useTooltip = ({
  text,
  position = 'bottom',
  isDisabled = false,
  anchor = { x: 'element', y: 'element' },
  offset = { mainAxis: 0, crossAxis: 0 },
  variant = 'tooltip'
}: Props): ReturnType<typeof useTooltipControlled> => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const disabled = isDisabled || !text;
  const { tooltipContent, tooltipProps } = useTooltipControlled({
    text,
    isOpen,
    position,
    isDisabled: disabled,
    offset,
    anchor,
    variant,
    onToggle: ({ value }) => setIsOpen(value)
  });

  return {
    tooltipContent,
    tooltipProps
  };
};
